import { render } from "./Cashier.vue?vue&type=template&id=23fdcf42"
import script from "./Cashier.vue?vue&type=script&lang=js"
export * from "./Cashier.vue?vue&type=script&lang=js"

import "./Cashier.vue?vue&type=style&index=0&id=23fdcf42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__